<template>
  <div>
    <Top/>
    <div class="cght_htmainbox">
      <div class="cght_htmain cgw1216">
         <!--左侧导航开始-->
        <div class="cght_htmainleft">
          <LeftNav :leftNavi='20'/>
        </div>
        <!--左侧导航完成-->
        <div class="cght_htmainright">
          <div style="width:100%;height:30px;padding-top: 5px;">
            <el-button type="primary" size="mini" round plain @click="Createtask()">添加开票信息</el-button>
            <el-button type="primary" size="mini" round plain @click="downloadht()">开票模板下载</el-button>
            <el-button type="primary" size="mini" round plain @click="Uploadorder()" icon="el-icon-upload2">开票信息EXCEl上传</el-button>
            <el-button type="primary" size="mini" round plain @click="Export()" icon="el-icon-download">开票信息导出</el-button>
            <div style="float: right;">
              <i class="el-icon-question" style="font-size:15px;color:#436aa6;" @click="dialogVisible = true"></i>
            </div>
          </div>
          <div class="cght_subpagemaina">
            <!--右边内容区域开始-->
            <el-row style="margin-bottom: 10px">
              <el-col :span="7">
                <el-date-picker
                  v-model="listQuery.addtimeBTTime"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                  @change="search"
                  size="small">
                </el-date-picker>
              </el-col>
              <el-col :span="3">
                <el-select size="small" v-model="listQuery.is_return_money" clearable placeholder="回款完成" @change="search" style="margin-right: 10px;">
                  <el-option label="未完成" value="1"></el-option>
                  <el-option label="已完成" value="2"></el-option>
                </el-select>
              </el-col>
              <el-col :span="6">
                <el-input size="small" v-model="listQuery.search" clearable placeholder="请输入购买方名称" style="width: 300px;" class="filter-item">
                  <el-button slot="append" @click="search">搜索</el-button>
                </el-input>
              </el-col>
            </el-row>
            <el-row style="position: static;margin-top: 8px;">
              <el-col :span="24" class="task">
                <el-table ref="singleTable" :data="list" border v-loading="qyloading" style="width: 100%">
                  <el-table-column align="center" type="selection" width="50"></el-table-column>
                  <el-table-column align="center" prop="factory" label="购买方名称"></el-table-column>
                  <el-table-column align="center" prop="addtime" label="开票日期"></el-table-column>
                  <el-table-column align="center" prop="tax_price" label="金额"></el-table-column>
                  <el-table-column align="center" prop="tax_amount" label="税额"></el-table-column>
                  <el-table-column align="center" prop="tax_total" label="价税合计"></el-table-column>
                  <el-table-column align="center" prop="salesperson" label="业务员"></el-table-column>
                  <el-table-column align="center" prop="invoice_details" label="发票明细"></el-table-column>
                  <el-table-column align="center" prop="return_money" label="已回款金额"></el-table-column>
                  <el-table-column align="center" label="回款完成" width="170px">
                    <template slot-scope="{row}">
                      <el-switch
                        style="display: block"
                        v-model="row.is_return_money"
                        :active-value=2
                        :inactive-value=1
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        @change="changeis_return_money(row, 'is_return_money')"
                        active-text="已完成"
                        inactive-text="未完成">
                      </el-switch>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" align="center" fixed="right" width="90">
                    <template slot-scope="scopes">
                      <el-button size="mini" type="text" @click="handleEdit(scopes.$index, scopes.row)">编辑</el-button>
                      <el-popover
                        :ref="`popover-${scopes.$index}`"
                        placement="top"
                        width="160"
                        trigger="click"
                        style="margin-left: 10px;"
                      >
                        <p>确定删除该信息吗？</p>
                        <div style="text-align: right; margin: 0;">
                          <el-button size="mini" type="text" @click="scopes._self.$refs[`popover-${scopes.$index}`].doClose()">取消</el-button>
                          <el-button type="primary" size="mini" @click="handleDelete(scopes.row,scopes.$index,scopes)">确定</el-button>
                        </div>
                        <el-button slot="reference" size="mini" type="text">删除</el-button>
                      </el-popover>
                    </template>
                  </el-table-column>
                </el-table>
                <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="getInvoicingList" :pageSizes="[10, 20, 30, 40, 50]"/>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
    <Bottom/>
    <el-dialog title="开票信息编辑" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
      <el-form :model="formData" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-row>
          <el-col :span="12">
            <el-form-item label="购买方名称" prop="factory">
              <el-input v-model="formData.factory" placeholder="请输入购买方名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开票日期" prop="addtime">
              <el-date-picker type="date" placeholder="请选择开票日期" v-model="formData.addtime" value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="金额" prop="tax_price">
              <el-input-number v-model="formData.tax_price" size="small" :precision="2" :min="0" :step="1" ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="税额" prop="tax_amount">
              <el-input-number v-model="formData.tax_amount" size="small" :precision="2" :min="0" :step="1" ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="业务员" prop="salesperson">
              <el-input v-model="formData.salesperson" placeholder="请输入业务员"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="发票明细">
              <el-input type="textarea" :rows="4" v-model="formData.invoice_details"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveInvoicing()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="开票信息EXCEl上传" :visible.sync="dialogOrderVisible" width="20%">
      <el-form :model="formOrderData" :rules="ruless" ref="FormOrder" label-width="100px" class="demo-ruleForm">
        <el-row>
          <el-col>
            <el-form-item label="上传文件" prop="filename">
              <el-upload
                ref="upload"
                class="upload-demo"
                :action="upload_url"
                :on-success="handlesuccess"
                :before-upload="beforeAvatarUpload"
                accept=".xls,.xlsx"
                :file-list="fileList"
                :headers="requestHeaders"
                :auto-upload="true"
                :multiple="false"
                :limit="1">
                <el-button slot="trigger" size="small" type="primary">上传模板文件</el-button>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogOrderVisible = false">取 消</el-button>
        <el-button type="primary" @click="importInvoicing()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="开票列表说明" :visible.sync="dialogVisible" width="50%">
      <el-carousel :autoplay="false" arrow="always" indicator-position="none" height="700px">
        <el-carousel-item v-for="(item,index) in srcList" :key="index">
          <el-image
            style="width: 100%;"
            :src="item"
            :preview-src-list="srcList">
          </el-image>
        </el-carousel-item>
      </el-carousel>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Top from '@/components/Member/Top'
import LeftNav from '@/components/Member/Left_nav'
import Bottom from '@/components/Member/Bottom'
import Pagination from '@/components/Pagination'
import { mapGetters } from 'vuex'
import api from '@/api/invoicing'
import { getToken } from '@/utils/auth'
import apiConfig from '../../../config/api.config.js'
import CountTo from 'vue-count-to'

export default {
  name: 'invoicing',
  components: { Top, LeftNav, Bottom, Pagination, CountTo },
  data () {
    return {
      api,
      list: [],
      total: 0,
      upload_url: apiConfig.baseUrl + '/admin/Upload/Upload_invoicing',
      requestHeaders: {
        'X-Token': getToken()
      },
      qyloading: false,
      fileList: [],
      listQuery: {
        limit: 10,
        order: 'addtime',
        page: 1,
        sort: 'DESC'
      },
      dialogFormVisible: false,
      dialogOrderVisible: false,
      locktype: false,
      formData: {
        id: null,
        factory: '',
        salesperson: '',
        tax_price: '',
        tax_amount: '',
        invoice_details: '',
        addtime: '',
        is_delete: 1
      },
      formOrderData: {
        filename: ''
      },
      rules: {
        factory: [{ required: true, message: '请输入购买方名称', trigger: 'blur' }],
        addtime: [{ required: true, message: '请选择开票日期', trigger: 'blur' }],
        tax_price: [{ required: true, message: '请输入金额', trigger: 'blur' }],
        tax_amount: [{ required: true, message: '请输入税额', trigger: 'blur' }],
        salesperson: [{ required: true, message: '请输入业务员', trigger: 'blur' }]
      }, // 上传订单
      ruless: {
        filename: [{ required: true, message: '请上传模板文件', trigger: 'change' }]
      },
      visible: false,
      dialogVisible: false,
      srcList: [
        'https://serv.nmzp.com/uploads/1/image/20240422/6687fd0195ca2376df44e5d3201a79b3.png',
        'https://serv.nmzp.com/uploads/1/image/20240422/edd1ff9871497b4d7cf9514d4211d323.png'
      ],
      primary_key: 'id',
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      }
    }
  },
  computed: {
    ...mapGetters([
      'current_user'
    ])
  },
  mounted () {
    this.getInvoicingList()
  },
  methods: {
    getInvoicingList () {
      this.qyloading = true
      if (this.current_user.id === 2 || this.current_user.id === 100) {
        // this.$delete(this.listQuery, 'user_id')
      } else {
        this.listQuery.user_id = this.current_user.id
      }
      api.getInvoicingList(this.listQuery).then(response => {
        this.list = response.data.items
        this.total = response.data.total
        this.qyloading = false
      })
    },
    downloadht () {
      window.open('https://serv.nmzp.com/uploads/doexcel/NMZPINVOICING.xlsx')
    },
    importInvoicing () {
      this.$refs['FormOrder'].validate((valid) => {
        if (valid) {
          api.importInvoicing(this.formOrderData).then((response) => {
            if (response.code === 20000) {
              this.$notify({
                title: '成功',
                message: response.message,
                type: 'success'
              })
              this.dialogOrderVisible = false
              this.getInvoicingList()
            }
          })
        }
      })
    },
    Createtask () {
      this.dialogFormVisible = true
      this.formData = {
        id: null,
        factory: '',
        salesperson: '',
        tax_price: '',
        tax_amount: '',
        invoice_details: '',
        addtime: '',
        is_delete: 1
      }
    },
    Uploadorder () {
      this.dialogOrderVisible = true
    },
    handleEdit (index, row) {
      this.dialogFormVisible = true
      this.formData = Object.assign({}, row)
    },
    handlesuccess (response, file) {
      this.subloading = false
      if (response.code === 20000) {
        // this.formData.filename = response.message
        this.formOrderData.filename = response.savename
      } else {
        this.$message.error(response.message)
      }
    },
    beforeAvatarUpload (file) {
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = testmsg === 'xls'
      const extension2 = testmsg === 'xlsx'
      const isLt2M = file.size / 1024 / 1024 < 10
      if (!extension && !extension2) {
        this.$message({
          message: '上传文件只能是 xls、xlsx格式!',
          type: 'warning'
        })
      }
      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 10MB!',
          type: 'warning'
        })
      }
      this.subloading = true
      return (extension || extension2) && isLt2M
    },
    handleDelete (row, index, scopes) {
      api.handleDelete({ id: row.id }).then(response => {
        this.getInvoicingList()
        scopes._self.$refs[`popover-${scopes.$index}`].doClose()
      })
    },
    saveInvoicing () {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          if (this.locktype) {
            // return false
          }
          this.locktype = true
          // this.formData.user_id = this.current_user.id
          api.saveInvoicing(this.formData).then(response => {
            this.dialogFormVisible = false
            this.locktype = false
            this.getInvoicingList()
            this.$notify({
              title: '成功',
              message: response.message,
              type: 'success'
            })
          })
        }
      })
    },
    search () {
      this.listQuery.page = 1
      this.getInvoicingList()
    },
    // 批量导出
    Export () {
      if (this.$refs.singleTable.selection.length > 0) {
        var ids = this.$refs.singleTable.selection.map(a => a[this.primary_key])
        api.export({id: ids}).then(response => {
          if (response.code === 20000) {
            window.open(response.savename)
          } else if (response.code === 30000) {
            this.$message.error(response.message)
          } else {
            this.$message.error('导出错误')
          }
        })
      } else {
        this.$message({ message: '请选择要导出的数据', type: 'error' })
      }
    },
    // 回款完成情况
    changeis_return_money (row, fieldName) {
      const params = { id: row.id }
      params[fieldName] = row[fieldName]
      api.changeis_return_money(params).then(res => {
        if (res.code === 20000) {
          this.$message({ message: '操作成功', type: 'success' })
        } else {
          this.$message({ message: '操作失败', type: 'error' })
        }
      })
    }
  }
}
</script>
<style scoped>
.cght_subpagemaina{
  padding-top: 25px;
}
.cgw1216{
  width: 1445px;
}
.cght_htmainright{
  width: 86%;
}
.ant-card-head {
  min-height: 48px;
  margin-bottom: 40px;
  padding: 0 24px;
  color: rgba(0, 0, 0, .85);
  font-weight: 500;
  font-size: 16px;
  background: 0 0;
  border-bottom: 1px solid #f0f0f0;
  border-radius: 2px 2px 0 0;
  background: #f8faff;
}
.ant-card-head-title {
  color: #1890ff;
  padding-top: 10px;
  float: left;
}
.ant-card-head-button {
  width: 90%;
  padding-top: 5px;
  float: left;
}
.filter-container {
  text-align: right;
  display: inline-block;
  float: right;
}
.highlight{
  background-color: #f0f0f0;
}
.el-popper{
  width:600px !important;
}
.ant-card-bottom{
  border-bottom: 2px solid #f0f0f0;
}
</style>



// WEBPACK FOOTER //
// src/view/member/invoicing.vue